/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CloseIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "close", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M18 7L7 18M7 7L18 18", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CloseIcon);
export default ForwardRef;
//# sourceMappingURL=closeIcon.js.map